import { TableSortingOrder } from "@/components/AppTable/ITable"

export enum EnumCertificatePageNames {
  CERT_PROVIDE = "cert_publish",
  CERT_CONSUME = "cert_discover",
  CERT_REQUESTS = "cert_requests",
  CERT_HISTORY = "cert_history",
  CERT_PROVIDED = "cert_provided",
  CERT_CONSUMED = "cert_consumed",
  INBOUND_CERT_REQUESTS = "inbound_cert_requests",
  OUTBOUND_CERT_STATUS = "outbound_cert_status"
}

export interface ICertificatesParams {
  modelId: string
  page: number
  size: number
  sorting?: {
    field: string
    type: TableSortingOrder
  }
}
export interface IRequestCertificate {
  certificateType: string
  receiverBpn: string
  locationBpns: string[]
  certificateStatus: string
}

export enum EnumCCMAPI {
  PUSH = "CompanyCertificateManagement-CCMAPI-Push:1.0.0",
  REQUEST = "CompanyCertificateManagement-CCMAPI-Request:1.0.0",
  STATUS = "CompanyCertificateManagement-CCMAPI-Status:1.0.0",
  AVAILABLE = "CompanyCertificateManagement-CCMAPI-Available:1.0.0"
}

export enum EnumCertificateStatus {
  AVAILABLE = "AVAILABLE",
  RECEIVED = "RECEIVED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PUSH = "PUSH",
  UPDATED = "UPDATED",
  SENT = "SENT",
  CREATED = "CREATED",
  FAILED = "FAILED"
}

export const CertificateStatusColor = {
  [EnumCertificateStatus.AVAILABLE]: "violet",
  [EnumCertificateStatus.RECEIVED]: "yellow",
  [EnumCertificateStatus.ACCEPTED]: "green",
  [EnumCertificateStatus.REJECTED]: "red",
  [EnumCertificateStatus.PUSH]: "blue",
  [EnumCertificateStatus.UPDATED]: "orange",
  [EnumCertificateStatus.SENT]: "cyan",
  [EnumCertificateStatus.CREATED]: "brown",
  [EnumCertificateStatus.FAILED]: "red"
}
export function getCertificateStatusColor(status: EnumCertificateStatus) {
  return CertificateStatusColor[status]
}

export interface ICertificate {
  document: {
    documentID: string
    header: {
      senderBpn: string
    }
    content: {
      document: {
        documentID: string
      }
      enclosedSites?: Array<{
        enclosedSiteBpn: string
      }>
    }
  }
  id: string
  publicProperties: {
    id: string
  }
}

export interface ICertificatesResponse {
  content: ICertificate[]
  totalPages: number
  totalElements: number
  size: number
}

export interface IJobPayload {
  job: {
    name: string
  }
  message: {
    header: {
      context: EnumCCMAPI
      receiverBpn: string
      version: string
      relatedMessageId?: string
    }
    content: Record<string, any>
  }
}

export interface ILocationBpn {
  name?: string
  bpns: string
  isChild?: boolean
  [key: string]: any
}

export type CertificateOrMessage =
  | ICertificate
  | {
      id: string
      document: {
        header: {
          senderBpn: string
          receiverBpn?: string
        }
        content?: {
          document?: {
            documentID: string
          }
          enclosedSites?: Array<{
            enclosedSiteBpn: string
          }>
        }
        documentID?: string
      }
      status?: string
    }

export interface ICreateJobPayloadOptions {
  context: EnumCCMAPI
  receiverBpn: string
  version: string
  jobName: string
  content: Record<string, any>
  relatedMessageId?: string
}
